import React from 'react';
import '../home/home.scss'
import {Container} from "react-bootstrap";
import ContactForm from "../../components/contactForm";


const Contact = () => {
    return (
        <Container>
            <h1 className='header'>Kontakt</h1>
            <ContactForm></ContactForm>
        </Container>
    )
}
export default Contact;
